import React from "react";
import { Sparkles, ArrowRight } from "lucide-react";
import { handlePrimaryCta, PRIMARY_CTA_LABEL } from "@/lib/contact";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="section bg-nav-950"
    >
      <div className="container-x">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-nav-900 via-nav-900 to-nav-950 border border-nav-800 text-white p-10 sm:p-16">
          <div
            aria-hidden="true"
            className="absolute -top-32 -left-32 h-[480px] w-[480px] rounded-full bg-brand/25 blur-3xl"
          />
          <div
            aria-hidden="true"
            className="absolute -bottom-32 -right-32 h-[420px] w-[420px] rounded-full bg-[#EC4899]/20 blur-3xl"
          />
          <div className="relative max-w-3xl">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-brand">
              <Sparkles className="h-3.5 w-3.5" />
              Stop losing high-intent visitors
            </span>
            <h2 className="mt-5 h-display text-4xl sm:text-6xl">
              See your booking funnel{" "}
              <span className="text-brand">before you pay anything.</span>
            </h2>
            <p className="mt-5 text-lg text-nav-300 max-w-xl">
              We build a working demo tailored to your business. If you like
              it, we move forward. If not, no pressure.
            </p>

            <div className="mt-8">
              <a
                href="#contact"
                onClick={handlePrimaryCta}
                data-testid="final-cta-primary"
                className="group inline-flex items-center gap-3 rounded-full bg-gradient-to-r from-[#7C3AED] to-[#EC4899] text-white
                  px-8 py-5 text-lg sm:text-xl font-bold
                  shadow-[0_20px_50px_-10px_rgba(124,58,237,0.65)]
                  hover:shadow-[0_26px_60px_-8px_rgba(236,72,153,0.6)] hover:scale-[1.03]
                  transition-all duration-200 relative"
              >
                <span
                  aria-hidden="true"
                  className="absolute inset-0 rounded-full bg-gradient-to-r from-[#7C3AED] to-[#EC4899] opacity-40 blur-xl animate-pulse"
                />
                <Sparkles className="h-6 w-6 relative" />
                <span className="relative">{PRIMARY_CTA_LABEL}</span>
                <ArrowRight className="h-5 w-5 relative" />
              </a>
              <p className="mt-3 text-sm text-nav-400">
                Free demo · No obligation · Same-day reply
              </p>
            </div>

            <div className="mt-8 grid sm:grid-cols-3 gap-4 text-sm">
              <div className="flex items-center gap-2 text-nav-300">
                <span className="h-2 w-2 rounded-full bg-emerald-400" />
                Built for your niche
              </div>
              <div className="flex items-center gap-2 text-nav-300">
                <span className="h-2 w-2 rounded-full bg-emerald-400" />
                Works with your tools
              </div>
              <div className="flex items-center gap-2 text-nav-300">
                <span className="h-2 w-2 rounded-full bg-emerald-400" />
                Yours to keep, free
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
